"use client"

import { useState } from "react";
import ClippedSquareBorder from "../../svg/ClippedSquareBorder";
import companybg from '@/assets/images/ASCII/companybg.png';
import Image from "../../Image";

function Partner({ children, number, href }: any) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className={`relative w-[285px] h-[100px] flex items-center justify-center z-20 overflow-clip ${href ? 'cursor-pointer' : ''}`}
      onMouseEnter={() => { setHovered(true); }}
      onMouseLeave={() => { setHovered(false); }}
      onClick={()=>{href ? window.open(href, '_blank'):0;}}
    >
      <div className={`transition-all ease-in-out duration-300 z-10 ${hovered ? 'grayscale-0 brightness-100' : 'grayscale brightness-50'}`}>
        {children}
      </div>
      {/*      <div className="absolute left-[50%] translate-x-[-50%] text-luminode-blue bottom-[16px] text-[12px] font-medium leading-tight">
        //&nbsp;{number}
  </div>*/}
      <div className="absolute">
        <ClippedSquareBorder />
      </div>
      <div className={`absolute ${hovered ? '' : 'hidden'}`}>
        <Image src={companybg} width={313} height={110} alt='' />
      </div>
    </div>
  );
}

export default Partner;